import publicSearch from "../../../api/publicSearch";

const requestsCache = new Map();
const resultsCache = new Map();

function makeCacheKey(requests, target) {
  return target + JSON.stringify(requests);
}

const apiRequest = async (requests, searchSource = "OPEN_SEARCH") => {
  const { data } = await publicSearch(requests, searchSource);

  return JSON.parse(data.publicSearch);
};

export const customSearchClient = {
  search(requests) {
    const key = makeCacheKey(requests, "search");
    const cachedResult = resultsCache.get(key);

    if (cachedResult) {
      if (Date.now() < cachedResult.expiry) {
        return Promise.resolve(cachedResult.data);
      }

      resultsCache.delete(key);
    }

    let request;

    if (requestsCache.has(key)) {
      request = requestsCache.get(key);
    } else {
      request = apiRequest(requests);

      requestsCache.set(key, request);
    }

    return request
      .then((results) => {
        resultsCache.set(key, {
          data: results,
          // Default expiry of 1 minute (60k ms)
          expiry: Date.now() + 60000,
        });

        return results;
      })
      .finally(() => {
        requestsCache.delete(key);
      });
  },

  clearCache() {
    requestsCache.clear();
    resultsCache.clear();
  },
};
